import React, { useState } from 'react';
import { Table, TableBody } from '@mui/material';
import { MemberState } from '../../../../../types/zinantis/members/membersType';
import MembersTableSectionHeader from './MembersTableSectionHeader';
import Card from '../../../components/Card';
import MemberRow from './MemberRow';
import Icon from '../../../../../muiComponents/Icon';
import Title from '../../../../components/Title';

interface MembersTableSectionProps {
    name: string;
    items: MemberState[];
    visibleSegmentName?: boolean;
    visibleNewMember?: boolean;
}

const MembersTableSection = (props: MembersTableSectionProps) => {
    const {
        name,
        items,
        visibleSegmentName = false,
        visibleNewMember = false,
    } = props;

    const [isOpen, setIsOpen] = useState(true);
    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <Card>
            <div className='flex flex-align-end flex-between padding10'>
                <Title className='text-size-20'>{name}</Title>
                <Icon
                    iconName={isOpen ? 'KeyboardArrowUp' : 'KeyboardArrowDown'}
                    className='cursor-pointer'
                    onClick={handleToggle}
                />
            </div>
            <Table size='small'>
                <MembersTableSectionHeader
                    isOpen={isOpen}
                    visibleSegmentName={visibleSegmentName}
                />
                {isOpen ? (
                    <TableBody>
                        {items.map(member => (
                            <MemberRow
                                key={member.id}
                                member={member}
                                visibleSegmentName={visibleSegmentName}
                                visibleNewMember={visibleNewMember}
                            />
                        ))}
                    </TableBody>
                ) : (
                    ''
                )}
            </Table>
        </Card>
    );
};

export default MembersTableSection;
